var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4eba2eed3b5a04b70acec1cbc5523b9ba548fbda"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["cabal-frontend@cabal-inc"]={id:"4eba2eed3b5a04b70acec1cbc5523b9ba548fbda"};
      